import MainTaskExplanationData from "./explanationData.json";
export default MainTaskExplanationData;
